import mirror from 'keymirror';
import has from 'lodash/has';
import Library from '../lib/library';
import { requestProgress } from './my-progress';
import { getSongByID } from './song';

export const actionTypes = mirror({
  CLEAR_WATCHING: null,
  CURRENT_LESSON_SET: null,
  FC_SIGNOUT: null,
  LESSONS_GET_ERROR: null,
  LESSONS_GET_IN_PROGRESS: null,
  LESSONS_GET_SUCCESS: null,
});

export const clearWatching = () => ({
  type: actionTypes.CLEAR_WATCHING,
});

const lessonsGetInProgress = () => ({
  type: actionTypes.LESSONS_GET_IN_PROGRESS,
});

const lessonsGetError = error => ({
  type: actionTypes.LESSONS_GET_ERROR,
  error,
});

const lessonsGetSuccess = results => ({
  type: actionTypes.LESSONS_GET_SUCCESS,
  results,
});

export function getLessons(options, unseenPath = false) {
  return async (dispatch, getState) => {
    try {
      dispatch(lessonsGetInProgress());
      const state = getState();
      const isPrivate =
        state.fenderConnect.subscriptions &&
        (state.fenderConnect.subscriptions.play === 'active' ||
          state.fenderConnect.subscriptions.play === 'pending');
      const results = await Library.getLessons(options, !isPrivate, unseenPath);
      const hasItems = has(results, 'items');
      if (hasItems) {
        const hasSongID = has(results.items[0], 'song');
        const songID = hasSongID ? results.items[0].song : null;
        await getSongByID(songID)(dispatch, getState);
      }
      dispatch(lessonsGetSuccess(results));
    } catch (err) {
      dispatch(lessonsGetError(err));
    }
  };
}

export function setCurrentLesson(lessonSlug, publicEndpoint = false) {
  return async (dispatch, getState) => {
    let state = getState();
    if (!state.lessons.slugs || !state.lessons.slugs[lessonSlug]) {
      await getLessons({ slug: lessonSlug }, publicEndpoint)(dispatch, getState);
      state = getState();
    } else if (!state.lessons.slugs[lessonSlug]['activity-lesson-video'].mp4720p) {
      await getLessons({ slug: lessonSlug })(dispatch, getState);
      state = getState();
    }
    if (state.lessons.slugs[lessonSlug]) {
      if (!publicEndpoint) {
        await requestProgress(state.lessons.slugs[lessonSlug].id, 'lessons', dispatch);
      }
      state = getState();
      if (state.lessons.slugs[lessonSlug]) {
        dispatch({
          type: actionTypes.CURRENT_LESSON_SET,
          lessonSlug,
          myProgress: state.myProgress,
        });
      }
    } else {
      dispatch(lessonsGetError('Lesson not found'));
    }
  };
}
